//@flow

import React from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

import {
  AUTOMATION_ARTICLES_URL,
  AUTOMATION_BLACKLIST_URL,
} from '../../../urls'
import { addBlacklistUrl } from '../../../sagas/automation/addBlacklist'
import { selectCurrentUser } from '../../../stores/currentUser'

import Blacklist from './Blacklist'
import Articles from './Articles'
import OpinaryInput from '../../Controls/OpinaryInput'
import PlusIcon from '../../Icons/PlusIcon'

import type { User, Dispatch, RootState } from '../../../types'

type Props = {
  addBlacklistUrl: Function,
  user: User,
  tab: string,
}

type State = {
  newUrl: string,
}

class AutomationPage extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      newUrl: '',
    }
  }

  handleChangeUrl(newUrl) {
    this.setState({ newUrl })
  }

  handleSaveUrl(user) {
    const { addBlacklistUrl } = this.props
    const { newUrl } = this.state
    if (!newUrl) {
      return
    }
    addBlacklistUrl(user.customerId, encodeURI(newUrl))
  }

  onSelect(index) {
    switch (index) {
      case 0:
        browserHistory.push(AUTOMATION_ARTICLES_URL)
        break
      case 1:
        browserHistory.push(AUTOMATION_BLACKLIST_URL)
        break
      default:
        browserHistory.push(AUTOMATION_ARTICLES_URL)
    }
  }

  render() {
    const { tab, user } = this.props

    return (
      <div className="w-100">
        <Tabs
          selectedIndex={tab === 'articles' ? 0 : 1}
          onSelect={this.onSelect}
        >
          <TabList
            className="flex"
            activeTabClassName="bg-op-con-dark"
            style={{ margin: 0, padding: 0, border: 'none' }}
          >
            <Tab className="w-20 bg-op-con-medium pointer white f5 pa2 flex items-center mr2">
              Automation Matched
            </Tab>
            <Tab className="w-20 bg-op-con-medium pointer white f5 pa2 flex items-center">
              Blacklist
            </Tab>
            <div className="w-40 flex mb2 ml-auto">
              <OpinaryInput
                className="ml-auto w-100 bb op-con-dark b--op-con-dark"
                inputClass="search-input"
                placeholder="Enter URL to be blacklisted"
                value={this.state.newUrl}
                onChange={e => this.handleChangeUrl(e.target.value)}
                icon={
                  <PlusIcon
                    className="op-con-dark pointer"
                    size="25"
                    onClick={e => this.handleSaveUrl(user)}
                  ></PlusIcon>
                }
              />
            </div>
          </TabList>
          <TabPanel>
            <Articles />
          </TabPanel>
          <TabPanel>
            <Blacklist />
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

function mapStateToProps(state: RootState) {
  return {
    user: selectCurrentUser(state),
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    addBlacklistUrl(customer, url) {
      dispatch(addBlacklistUrl(customer, url))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AutomationPage)



// WEBPACK FOOTER //
// ./src/components/Pages/Automation/index.js